<template>
  <section
    id="checkoutTermsAndConditions"
    :class="[openClass, 'expandable_section']"
  >
    <h2
      class="expandable_header"
      @click="updateSection(sectionName)"
    >
      {{ number }}. {{ $t('checkout.docusign.sectionTitle') }}
    </h2>
    <div class="expandable_content">
      <button
        v-if="billingInfoMissing"
        class="continue-button btn btn-primary"
        @click="updateSection('address')"
      >
        {{ $t("checkout.payment.updateInfo") }}
      </button>
      <div
        v-else
        class="terms-and-conditions-container"
      >
        <div
          v-if="docusignLoader"
          class="processing-docusign"
        >
          <div class="loading-background" />
          <div class="loading-icon" />
        </div>
        <p>
          <span
            class="click-here-link"
            @click="generateDocusign"
          >
            {{ $t('checkout.docusign.link') }}
          </span>
          {{ $t('checkout.docusign.description') }}
        </p>
        <p class="small">
          {{ $t('checkout.docusign.finePrint') }}
        </p>
        <div
          class="continue-button btn btn-primary"
          @click="generateDocusign"
        >
          {{ $t('checkout.docusign.button') }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    number: {
      default: null,
      require: false,
      type: Number
    }
  },

  data() {
    return {
      sectionName: 'termsAndConditions',
      sectionNext: 'payment'
    }
  },

  computed: {
    ...mapState('checkout', {
      billing: state => state.billing,
      docusignUrl: state => state.docusignUrl,
      docusignLoader: state => state.docusignLoader
    }),
    selected() {
      return this.$store.state.checkout.section == this.sectionName
    },
    openClass() {
      return (this.selected) ? 'open' : ''
    },
    billingInfoMissing() {
      return jQuery.isEmptyObject(this.billing.firstName) ||
             jQuery.isEmptyObject(this.billing.lastName) ||
             jQuery.isEmptyObject(this.billing.phoneNumber) ||
             jQuery.isEmptyObject(this.billing.address1) ||
             jQuery.isEmptyObject(this.billing.city) ||
             this.billing.state == 'missing state value' ||
             jQuery.isEmptyObject(this.billing.city) ||
             this.invalidCountry ||
             this.invalidPostalCode
    },
  },

  methods: {
    ...mapActions('checkout', ['updateSection', 'generateDocusign'])
  }
}
</script>
